'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'house-chimney';
var width = 512;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = 'M464 272l48 0 0-48-48-45 0-131-96 0 0 41-112-105-256 240 0 48 48 0 0 240 416 0 0-240zM320 464l-128 0 0-144 128 0 0 144z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;